import { motion } from "framer-motion";
import { Reveal } from "./Reveal";
import { useContent } from "@/content";

export const Final = () => {
  const c = useContent();

  return (
    <footer id="contact" className="border-t border-white/10" data-testid="final-section">
      <div className="min-h-[85vh] flex flex-col items-center justify-center px-6 sm:px-12 py-24 text-center">
        <div className="overflow-hidden max-w-6xl">
          <motion.p
            initial={{ y: "60%", opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 1.2, ease: [0.16, 1, 0.3, 1] }}
            className="font-display font-extrabold uppercase tracking-tighter leading-[0.95] text-[clamp(2rem,7vw,6rem)] text-aura-gradient"
            data-testid="final-statement"
          >
            {c.final_statement || "The future needs people who can think before they follow."}
          </motion.p>
        </div>

        <Reveal delay={0.2}>
          <p className="font-meta text-xs sm:text-sm tracking-[0.35em] text-neutral-400 mt-12" data-testid="final-meta">
            {c.final_meta || "JEREMIAH / AGE 16 / 2026 →"}
          </p>
          <p className="font-meta text-[10px] sm:text-xs tracking-[0.35em] text-neutral-600 mt-3">
            {c.final_sub || "THIS ARCHIVE IS STILL BEING WRITTEN."}
          </p>
        </Reveal>

        <Reveal delay={0.3}>
          <div className="flex flex-wrap items-center justify-center gap-4 sm:gap-8 mt-14">
            <a
              href="https://www.instagram.com/j.erem1ah/"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="contact-instagram-link"
              className="font-meta text-xs tracking-[0.25em] border border-blue-200/30 rounded-full px-6 py-3 hover:bg-[#4F7CFF] hover:border-[#4F7CFF] hover:text-white transition-colors duration-300"
            >
              INSTAGRAM ↗
            </a>
            <a
              href="https://youtube.com/@j.3r3m1ah"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="contact-youtube-link"
              className="font-meta text-xs tracking-[0.25em] border border-blue-200/30 rounded-full px-6 py-3 hover:bg-[#4F7CFF] hover:border-[#4F7CFF] hover:text-white transition-colors duration-300"
            >
              YOUTUBE ↗
            </a>
            <a
              href="#archive"
              onClick={(e) => {
                e.preventDefault();
                window.__lenis?.scrollTo("#archive", { duration: 1.4 });
              }}
              data-testid="contact-archive-link"
              className="font-meta text-xs tracking-[0.25em] border border-blue-200/30 rounded-full px-6 py-3 hover:bg-[#4F7CFF] hover:border-[#4F7CFF] hover:text-white transition-colors duration-300"
            >
              READ THE ARCHIVE
            </a>
          </div>
        </Reveal>
      </div>

      <div className="flex flex-col sm:flex-row justify-between gap-3 px-6 sm:px-12 lg:px-20 py-8 border-t border-white/10">
        <span className="font-meta text-[10px] tracking-[0.25em] text-neutral-600">© 2026 JEREMIAH WOMACK</span>
        <span className="font-meta text-[10px] tracking-[0.25em] text-neutral-600">
          {(c.hero_statement || "The future is made in the present.").toUpperCase()}
        </span>
      </div>
    </footer>
  );
};
